import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'
import { v2WorkCodeKeys } from './use-v2-workcode-find-query'

type RemoveWorkCodeBody = Parameters<typeof apiClient.v2.apiV2WorkcodeElRemove>[0]

const removeWorkCode = async (body: RemoveWorkCodeBody) => {
  const { data } = await apiClient.v2.apiV2WorkcodeElRemove(body)
  return checkApiResponse(data)
}

export const useV2WorkCodeRemoveMutation = ({ options }: MutationComposableParams<unknown, RemoveWorkCodeBody> = {}) => {
  const queryClient = useQueryClient()
  return useMutation(() => {
    const resolved = resolveMaybeGetter(options ?? {})
    return {
      mutationFn: removeWorkCode,
      ...resolved,
      // 저장 성공 시 도메인 캐시를 무효화한다 — 다음 조회가 fresh 데이터를 가져온다
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries({ queryKey: v2WorkCodeKeys.all })
        return (resolved as { onSuccess?: (...args: unknown[]) => unknown }).onSuccess?.(data, variables, context)
      },
    }
  })
}
